/**
 * Helper functions for SongsPage
 */

/**
 * Get the page title based on current mode
 */
export const getPageTitle = ({ isChangeDefaultSongFlow, isEditPlaylistFlow, isGalleryMode, selectedGenre, isAssignToContactFlow }) => {
  if (isChangeDefaultSongFlow || isAssignToContactFlow) return 'איזה שיר לנגן?';
  if (isEditPlaylistFlow) return 'הפלייליסט שלי';
  if (isGalleryMode) return 'הפלייליסט שלי';
  return selectedGenre?.title || selectedGenre?.description || 'עשו לנו את השבוע';
};

/**
 * Get the hero background style
 */
export const getHeroBackgroundStyle = ({ isGalleryMode, isEditPlaylistFlow, isChangeDefaultSongFlow, selectedGenre, myPlaylistHeroImage }) => {
  // If in gallery or edit/change flows, prefer a provided MyPlaylistHeroImage URL
  if (isGalleryMode || isEditPlaylistFlow || isChangeDefaultSongFlow) {
    if (isGalleryMode && myPlaylistHeroImage) {
      return { backgroundImage: `url(${myPlaylistHeroImage})`, backgroundSize: 'cover', backgroundPosition: 'center' };
    }
    return { background: 'var(--gradient, linear-gradient(180deg, #810EA9 0%, #BC32CE 100%))' };
  }
  return { backgroundImage: `url(${selectedGenre?.image})` };
};

/**
 * Get the CSS class names for the page container
 */
export const getPageClassName = ({ isGalleryMode, isEditPlaylistFlow, isChangeDefaultSongFlow, isAssignToContactFlow  }) => {
  const classes = ['songs-page'];
  if (isGalleryMode ) classes.push('songs-page--gallery');
  if (isEditPlaylistFlow) classes.push('songs-page--gallery');
  if (isChangeDefaultSongFlow || isAssignToContactFlow) classes.push('songs-page--change-default');
  if (isAssignToContactFlow) classes.push('songs-page--assign-to-contact');
  return classes.join(' ');
};

/**
 * Check if empty messages should be shown
 */
export const getEmptyStates = ({ isChangeDefaultSongFlow, isEditPlaylistFlow, songs }) => {
  return {
    showEmptyChangeDefaultMessage: isChangeDefaultSongFlow && (!songs || songs.length === 0),
    showEmptyPlaylistMessage: isEditPlaylistFlow && (!songs || songs.length === 0),
  };
};
